module.exports = __webpack_public_path__ + "img/inviteBg.cf2b4dcd.png";